import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Instalacija",
  "description": "",
  "published": "2006-04-21T00:00:00.000Z",
  "redirect_from": ["/blog/instalacija/swizec/429"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`[`}{`size=13]Kot kaze je bila instalacija te strani, oziroma vsaj njene osnove, koncno uspesna. Kaksen klise so teli prvi poskusni posti... heh.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      